var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{class:_vm.$style.myPhoto,attrs:{"src":_vm.myPhoto2Src,"width":_vm.p_width,"height":_vm.p_width,"title":_vm.$langs.title('photo_itsMe')},on:{"load":function($event){return _vm.$emit('imgPhotoLoad')}}})
}
var staticRenderFns = []

export { render, staticRenderFns }